var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtonPassLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M353.274 214.391C408.835 158.832 436.614 131.052 468.648 120.644C496.825 111.489 527.175 111.489 555.352 120.644C587.386 131.052 615.165 158.832 670.726 214.391L809.608 353.274C865.169 408.835 892.948 436.614 903.356 468.648C912.512 496.825 912.512 527.175 903.356 555.352C892.948 587.386 865.169 615.165 809.608 670.726L670.726 809.608C615.165 865.169 587.386 892.948 555.352 903.356C527.175 912.512 496.825 912.512 468.648 903.356C436.614 892.948 408.835 865.169 353.274 809.608L327.162 780.336C311.361 762.621 303.462 753.763 297.827 743.688C292.833 734.754 289.166 725.137 286.947 715.144C284.444 703.878 284.444 692.008 284.444 668.271V355.729C284.444 331.992 284.444 320.122 286.947 308.855C289.166 298.863 292.833 289.246 297.827 280.311C303.462 270.237 311.361 261.38 327.162 243.665L353.274 214.391Z",
    fill: "url(#paint0_radial_12155_41873)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M353.274 214.391C408.835 158.832 436.614 131.052 468.648 120.644C496.825 111.489 527.175 111.489 555.352 120.644C587.386 131.052 615.165 158.832 670.726 214.391L809.608 353.274C865.169 408.835 892.948 436.614 903.356 468.648C912.512 496.825 912.512 527.175 903.356 555.352C892.948 587.386 865.169 615.165 809.608 670.726L670.726 809.608C615.165 865.169 587.386 892.948 555.352 903.356C527.175 912.512 496.825 912.512 468.648 903.356C436.614 892.948 408.835 865.169 353.274 809.608L327.162 780.336C311.361 762.621 303.462 753.763 297.827 743.688C292.833 734.754 289.166 725.137 286.947 715.144C284.444 703.878 284.444 692.008 284.444 668.271V355.729C284.444 331.992 284.444 320.122 286.947 308.855C289.166 298.863 292.833 289.246 297.827 280.311C303.462 270.237 311.361 261.38 327.162 243.665L353.274 214.391Z",
    fill: "url(#paint1_linear_12155_41873)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M343.356 224.303C371.135 196.524 385.024 182.634 401.041 177.43C415.13 172.852 430.305 172.852 444.393 177.43C460.41 182.634 474.3 196.524 502.079 224.303L710.406 432.629C738.185 460.408 752.074 474.3 757.279 490.314C761.856 504.403 761.856 519.581 757.279 533.669C752.074 549.686 738.185 563.576 710.406 591.354L502.079 799.681C474.3 827.46 460.41 841.35 444.393 846.555C430.305 851.132 415.13 851.132 401.041 846.555C385.024 841.35 371.135 827.46 343.356 799.681L214.391 670.717C158.832 615.157 131.052 587.378 120.644 555.346C111.489 527.167 111.489 496.816 120.644 468.639C131.052 436.605 158.832 408.826 214.391 353.266L343.356 224.303Z",
    fill: "url(#paint2_radial_12155_41873)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12155_41873",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(354.145 925.744) rotate(-58.142) scale(664.835 1039.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F6C592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#EBB6A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324466,
    stopColor: "#DFA5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42875,
    stopColor: "#D397BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53375,
    stopColor: "#C486CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64875,
    stopColor: "#B578D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77125,
    stopColor: "#A166E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89125,
    stopColor: "#8B57F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#704CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12155_41873",
    x1: 326.713,
    y1: -44.3649,
    x2: 481.598,
    y2: 901.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D4AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392009,
    stopColor: "#B39FFB",
    stopOpacity: 0.978022
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE8DB",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_12155_41873",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(295.746 844.786) rotate(-58.142) scale(534.758 836.255)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F6C592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#EBB6A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324466,
    stopColor: "#DFA5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42875,
    stopColor: "#D397BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53375,
    stopColor: "#C486CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64875,
    stopColor: "#B578D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77125,
    stopColor: "#A166E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89125,
    stopColor: "#8B57F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#704CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtonPassLight);
export default __webpack_public_path__ + "static/media/ProtonPassLight.c05002ea2bafd8e71e4b954db9c176cf.svg";
export { ForwardRef as ReactComponent };